import React, { useEffect, useState } from 'react';

import { Alert, Card, CardBody } from 'reactstrap';

import { toAbsolutePublicUrl } from '../../../utils/AssetHelpers';
import { useAlertContext } from '../components/contexts/AlertProvider';
// import Toast from '../../../components/widgets/Toast';

import './Layout.css';

/**
 * 
 * @param param0 
 * @returns 
 */
const Layout = ({title,  children }) => {

    const publicUrl = process.env.PUBLIC_URL + "/";

    /**
     * 
     */
    const { showAlert, text: alertText, color: alertColor } = useAlertContext();

    /**
     * 
     */
    const [presentAlert, setPresentAlert] = useState(showAlert);

    /**
     * 
     * @returns 
     */
    const dismissAlert = () => setPresentAlert(false);

    /**
     * 
     */
    useEffect(() => {
        setPresentAlert(showAlert);
    }, [showAlert])

    /**
     * 
     */
    return (
        <div className='auth-page-content d-flex flex-column align-items-center flex-column-fluid'>
            <div className="background-overlay"></div>
            {/*  */}
            <div className="col-logo d-flex flex-center w-lg-70 w-xl-50 pt-5  px-10">
                <div className="d-flex flex-center flex-lg-start flex-column position-relative">
                    {/* begin::Logo */}
                    <div className='login-logo-wrapper d-flex align-items-center justify-content-center position-relative mb-2'>
                        <img
                            className="img-fluid"
                            src={`${publicUrl}logo.png`}
                            width={100}
                            alt="Logo"
                        />
                    </div>
                    {/* end::Logo */}
                    {/* begin::Title */}
                    {/* <div className='title-wrapper d-flex flex-center text-center position-relative'>
                        <h2 className="title h6 fw-normal m-0 text-white">Agence de développement et d'encadrement des petites et moyennes entreprises</h2>
                    </div> */}
                    {/* end::Title */}
                </div>
            </div>
            {/*  */}
            {/*  */}
            <div className="col-form d-flex flex-center w-lg-70 w-xl-50 pt-5 pb-10 px-5 px-sm-10">
                <Card className="rounded-3">
                    <CardBody className="pt-6 pb-8 px-5 px-sm-10 px-md-12">
                        {/* <div className="d-flex flex-center flex-column gap-3">
                            <div className='text-center'>
                                <span className='fs-9 text-uppercase'>Ministère de l'industrie et du commerce</span>
                            </div>
                            <div className='d-flex flex-row'>
                                <img
                                    className="img-fluid h-24px"
                                    src={toAbsolutePublicUrl('/assets/media/images/icons/svg/flag-of-senegal.svg')}
                                    alt="Drapeau du Sénégal"
                                />
                            </div>
                            <div className='text-center'>
                                <span>MECANISME DE GESTION DES PLAINTES</span>
                            </div>
                        </div> */}
                        <div className="text-center my-6">
                        {
                            showAlert &&
                            <Alert
                                isOpen={presentAlert}
                                toggle={dismissAlert}
                                color={alertColor}
                            >
                            {
                                alertText
                            }
                            </Alert>
                        }
                            <h1 className="fw-semibold fs-3 mb-0">{title}</h1>
                        </div>
                        { children }
                        <div id="recaptcha-container"></div>
                    </CardBody>
                </Card>
            </div>
            {/*  */}
            {/* begin::Toast container */}
            {/* <Toast hideProgressBar={true} /> */}
            {/* end::Toast container */}
        </div>
    );
};

export default Layout;
